import { Decimal } from '../../datastructures';
import { createAsyncAtom } from '../../lib/state';
import poolDataAtom from './poolDataAtom';

const poolRewardsAprAtom = createAsyncAtom(async get => {
  const poolData = await get(poolDataAtom);

  const poolRewardAprs: Record<string, Decimal> = {};

  Object.entries(poolData).forEach(([poolId, data]) => {
    poolRewardAprs[poolId] = data.rewardApr;
  });

  return poolRewardAprs;
});
export default poolRewardsAprAtom;
